import { Select } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { DataGroupEntity } from "src/app/features/DataGroup/types/DataGroupEntity";
import { getAssignedDataGroup, getUserIdFromToken } from "../../../core/router/auth";
import type { FormInputProps } from "../../Form/types/types";
import { SelectInput } from "../../Select/SelectInput";
import { useLoadDataGroupsQuery } from "../serverApi";

interface DataGroupProps extends FormInputProps<DataGroupEntity> {}

/**
 * Gets DataGroups from BE and display select box with received data.
 */
export const DataGroupSelector: FC<DataGroupProps> = ({ onChange, value }) => {
    const { t } = useTranslation();
    const user = {
        userId: getUserIdFromToken(),
    };
    const { data, isLoading } = useLoadDataGroupsQuery({ userId: user.userId });

    const handleChange = (code?: string) => {
        if (code) {
            const dataGroup = data?.find((_) => _.code === code);
            if (onChange && dataGroup) {
                onChange(dataGroup);
            }
        }
    };

    return (
        <SelectInput
            name="data_group_selector"
            placeholder={t("dataGroup.selectDataGroup")}
            onChange={handleChange}
            defaultValue={getAssignedDataGroup()?.code}
            isLoading={isLoading}
            value={value?.code}
        >
            {data &&
                data
                    .filter((dataGroup) => dataGroup.code)
                    .map((dataGroup: DataGroupEntity) => (
                        <Select.Option value={dataGroup.code} key={dataGroup.code} displayName={dataGroup.name}>
                            {dataGroup.name}
                        </Select.Option>
                    ))}
        </SelectInput>
    );
};
